<template>
  <v-app>
    <loading-dialog />
    <div id="header">
      <div class="header-wrap">
        <div>
          <div class="logo">
            <img
              :src="require('@/assets/img/landing/logo-dark.png')"
              :srcset="
                require('@/assets/img/landing/logo-dark.png') +
                ' 1x, ' +
                require('@/assets/img/landing/logo-dark@2x.png') +
                ' 2x, ' +
                require('@/assets/img/landing/logo-dark@3x.png') +
                ' 3x'
              "
              alt="Tape"
            />
          </div>
          <div class="button">
            <ul>
              <li>
                <router-link tag="button" :to="{ name: 'SignIn' }">
                  {{ $t('signIn') }}
                </router-link>
              </li>
              <li>
                <!-- <router-link tag="button" :to="{ name: 'SignUp' }"> -->
                <router-link tag="button" :to="{ name: 'SignIn' }">
                  {{ $t('tryForFree') }}
                </router-link>
              </li>
            </ul>
          </div>
          <div style="position: fixed; bottom: 50px; left: 60px; z-index: 200">
            <a
              href="https://www.producthunt.com/posts/tape-4?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-tape&#0045;4"
              target="_blank"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=346605&theme=light"
                alt="Tape - Replace&#0032;Video&#0032;Calls&#0032;with&#0032;Threaded&#0032;Video&#0032;Messaging | Product Hunt"
                style="width: 250px; height: 54px"
                width="250"
                height="54"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="container">
      <div class="main-wrap">
        <div class="main-con">
          <div class="main-title" data-aos="fade-up" data-aos-duration="1000">
            <span v-html="$t('heroPhrase0')" />
            {{ $t('heroPhrase1') }}
          </div>

          <div class="main-sub-title" data-aos="slide-up" data-aos-duration="1000">
            {{ $t('heroDescription0') }}
            <span v-html="$t('heroDescription1')" />
            {{ $t('heroDescription2') }}
          </div>
          <!-- <router-link class="btn-get-started" tag="button" :to="{ name: 'SignUp' }" data-aos="zoom-in"> -->
          <router-link class="btn-get-started" tag="button" :to="{ name: 'SignIn' }" data-aos="zoom-in">
            {{ $t('getStarted') }}
          </router-link>
          <button @click="moveBookDemo" class="btn-book-demo" data-aos="zoom-in">
            {{ $t('bookDemo') }}
          </button>
        </div>
      </div>

      <!-- Swipe View 주석처리 -->
      <!-- <div class="roll-wrap">
        <div class="roll-con">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img :src="require('@/assets/img/landing/landing-meeting-detail.png')" alt="Meeting Detail" />
              </div>
              <div class="swiper-slide">
                <img :src="require('@/assets/img/landing/landing-meetings.png')" alt="Workspace" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div> -->

      <div class="intro-wrap">
        <div class="intro-con">
          <img :src="require('@/assets/img/landing/landing-frame-01.png')" alt="Record it, Share it" />
        </div>
      </div>

      <div class="txt-wrap" data-aos="zoom-in" data-aos-duration="1500" data-aos-offset="500" data-aos-delay="50">
        <div class="txt-con">
          <div class="txt">
            <div class="wrap">
              <h3 v-html="$t('diffTitle0')"></h3>
              <p>{{ $t('diffDescription0') }}</p>
            </div>
          </div>
          <div class="image">
            <img :src="require('@/assets/img/landing/landing-frame-02.png')" alt="Topic based conversation" />
          </div>
        </div>
      </div>

      <div class="txt-wrap" data-aos="zoom-in" data-aos-duration="1500" data-aos-offset="500" data-aos-delay="50">
        <div class="txt-con">
          <div class="txt">
            <div class="wrap">
              <h3 v-html="$t('diffTitle1')"></h3>
              <p>{{ $t('diffDescription1') }}</p>
            </div>
          </div>
          <div class="image">
            <img :src="require('@/assets/img/landing/landing-frame-03.png')" alt="Topic based conversation" />
          </div>
        </div>
      </div>

      <div class="txt-wrap" data-aos="zoom-in" data-aos-duration="1500" data-aos-offset="500" data-aos-delay="50">
        <div class="txt-con">
          <div class="txt">
            <div class="wrap">
              <h3 v-html="$t('diffTitle2')"></h3>
              <p>{{ $t('diffDescription2') }}</p>
            </div>
          </div>
          <div class="image">
            <img :src="require('@/assets/img/landing/landing-frame-04.png')" alt="Topic based conversation" />
          </div>
        </div>
      </div>

      <div class="bundle-wrap">
        <div class="bundle-con">
          <h3 data-aos="zoom-in">{{ $t('usecaseTitle') }}</h3>
          <p data-aos="zoom-in" v-html="$t('usecaseDescription')" />
          <div class="bundle">
            <div class="bundle-item" data-aos="zoom-in-up">
              <!-- <img
                :src="require('@/assets/img/landing/bundle/01.png')"
                :srcset="
                  require('@/assets/img/landing/bundle/01.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/bundle/01@2x.png') +
                  ' 2x, ' +
                  require('@/assets/img/landing/bundle/01@3x.png') +
                  ' 3x'
                "
                alt="ico image"
              /> -->
              <h6>Daily Standup</h6>
              <p v-html="$t('usecaseDailyStandup')"></p>
            </div>
            <div class="bundle-item" data-aos="zoom-in-up">
              <!-- <img
                :src="require('@/assets/img/landing/bundle/02.png')"
                :srcset="
                  require('@/assets/img/landing/bundle/02.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/bundle/02@2x.png') +
                  ' 2x, ' +
                  require('@/assets/img/landing/bundle/02@3x.png') +
                  ' 3x'
                "
                alt="ico image"
              /> -->
              <h6>Feedbacks & Questions</h6>
              <p v-html="$t('usecaseFeedbackQuestion')"></p>
            </div>
            <div class="bundle-item" data-aos="zoom-in-up">
              <!-- <img
                :src="require('@/assets/img/landing/bundle/03.png')"
                :srcset="
                  require('@/assets/img/landing/bundle/03.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/bundle/03@2x.png') +disabled
                  ' 2x, ' +
                  require('@/assets/img/landing/bundle/03@3x.png') +
                  ' 3x'
                "
                alt="ico image"
              /> -->
              <h6>Code Review</h6>
              <p v-html="$t('usecaseCodeReview')"></p>
            </div>
            <div class="bundle-item" data-aos="zoom-in-up">
              <!-- <img
                :src="require('@/assets/img/landing/bundle/04.png')"
                :srcset="
                  require('@/assets/img/landing/bundle/04.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/bundle/04@2x.png') +
                  ' 2x, ' +
                  require('@/assets/img/landing/bundle/04@3x.png') +
                  ' 3x'
                "
                alt="ico image"
              /> -->
              <h6>Project Updates</h6>
              <p v-html="$t('usecaseProjectUpdate')"></p>
            </div>
            <div class="bundle-item" data-aos="zoom-in-up">
              <!-- <img
                :src="require('@/assets/img/landing/bundle/05.png')"
                :srcset="
                  require('@/assets/img/landing/bundle/05.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/bundle/05@2x.png') +
                  ' 2x, ' +
                  require('@/assets/img/landing/bundle/05@3x.png') +
                  ' 3x'
                "
                alt="ico image"
              /> -->
              <h6>Webinar</h6>
              <p v-html="$t('usecaseWebinar')"></p>
            </div>
            <div class="bundle-item" data-aos="zoom-in-up">
              <!-- <img
                :src="require('@/assets/img/landing/bundle/06.png')"
                :srcset="
                  require('@/assets/img/landing/bundle/06.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/bundle/06@2x.png') +
                  ' 2x, ' +
                  require('@/assets/img/landing/bundle/06@3x.png') +
                  ' 3x'
                "
                alt="ico image"
              /> -->
              <h6>And many more</h6>
              <p v-html="$t('usecaseEtc')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer">
      <div class="footer-wrap">
        <v-row>
          <v-col>
            <v-row>
              <img
                :src="require('@/assets/img/landing/logo-emblem.png')"
                :srcset="
                  require('@/assets/img/landing/logo-emblem.png') +
                  ' 1x, ' +
                  require('@/assets/img/landing/logo-emblem@2x.png') +
                  ' 2x, ' +
                  require('@/assets/img/landing/logo-emblem@3x.png') +
                  ' 3x'
                "
                alt="logo-emblem"
              />
            </v-row>
            <v-row class="mt-10">
              <v-icon
                onclick="window.open('https://www.linkedin.com/company/tape-ooo')"
                color="#96a7af"
                class="mr-2 pointer"
              >
                mdi-linkedin
              </v-icon>
              <v-icon onclick="window.open('https://twitter.com/tape_team')" color="#96a7af" class="mr-2 pointer">
                mdi-twitter
              </v-icon>
              <v-icon
                onclick="window.open('https://join.slack.com/t/tapecorp/shared_invite/zt-18nlv5acg-VPeEJxV~4LQHv~Yh9JTNRQ')"
                color="#96a7af"
                class="mr-2 pointer"
              >
                mdi-slack
              </v-icon>
            </v-row>
          </v-col>
          <v-col>
            <h3>Product</h3>
            <div class="footer-item">
              <p
                class="pointer link"
                onclick="window.open('https://taperlabs.notion.site/About-Taper-Labs-0d0186154ec743e68575d0b54a417e48')"
              >
                About
              </p>
            </div>
            <div class="footer-item">
              <p class="pointer link" onclick="window.open('https://tape.frill.co')">Roadmap</p>
            </div>
          </v-col>
          <v-col>
            <h3>Legal</h3>
            <div class="footer-item"><p class="pointer link" v-html="$t('termsOfService')"></p></div>
            <div class="footer-item"><p class="pointer link" v-html="$t('privacyPolicy')"></p></div>
          </v-col>
        </v-row>
        <v-row>
          <div class="copyright">
            <p>© 2022 Taper Labs, Inc. All rights reserved</p>
          </div>
        </v-row>
        <!-- TODO: 아래 링크 주소 언어별로 변경 -->
        <!-- <li onclick="window.open('https://taperlabs.notion.site/b8e7494516914aba8f12782c3a92ddc3')">
            Terms of Service
          </li> -->
        <!-- <li onclick="window.open('https://taperlabs.notion.site/f348bcefbed04f5d9b3196a3a04e732c')">
            Privacy Policy
          </li> -->

        <!-- <li>
            <select style="color: white" v-model="$i18n.locale" @change="updateLanguage">
              <option value="en">English</option>
              <option value="ko">한국어</option>
            </select>
          </li> -->
      </div>
    </div>
    <loading-dialog />
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import LoadingDialog from './modal/LoadingDialog'
import Swiper from 'swiper/swiper-bundle'
import 'swiper/swiper-bundle.css'

export default {
  name: 'Home',
  components: {
    LoadingDialog,
  },
  data: () => ({
    langs: ['en', 'ko'],
  }),
  created() {
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '홈',
        firebase_screen_class: 'Home',
      },
    })
  },
  mounted() {
    const bullet = ['Meeting', 'Workspace']
    // eslint-disable-next-line no-undef, no-unused-vars
    const swiper = new Swiper('.swiper-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      autoplay: {
        delay: 4000,
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<div class="' + className + '"><span>' + bullet[index] + '</span></div>'
        },
      },
    })

    this.$aos.init()
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  methods: {
    moveBookDemo() {
      window.open('https://calendly.com/jay-from-tape/1-on-1', '_blank')
    },
    // updateLanguage() {
    //   localStorage.setItem('Language', this.$i18n.locale)
    // },
    ...mapActions(['setSignOut']),
  },
}
</script>
<style scoped>
@import '../assets/css/landing/common.css';
@import '../assets/css/landing/tape.css';
@import url('https://unpkg.com/aos@2.3.1/dist/aos.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.1/css/swiper.min.css');

select option {
  background-color: #2a3c44;
  border-color: #2a3c44;
  color: #fff;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 50%;
  margin-right: 2rem;
  padding-right: 2rem;
}

.theme--light.v-application {
  background: none !important;
}

.footer-wrap >>> .v-icon:hover {
  color: #eee !important;
}
</style>
